/**
 * ResolutionOptions - Action selector for overlap resolution
 *
 * This component provides a dropdown selector for choosing how to resolve
 * meal scheduling conflicts, with contextual options based on mode.
 */

import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Select from '@pro/components/Widgets/Select.react';
import { getAvailableActions } from '@utils/overlapResolution';

const ResolutionOptions = ({ value, onChange, mode = 'reschedule', disabled = false }) => {
    const options = useMemo(() => getAvailableActions(mode), [mode]);

    const selectedOption = useMemo(() =>
        options.find(opt => opt.value === value),
        [options, value]
    );

    return (
        <Select
            defaultClassName="el-select-container el-select-raspberry"
            className="resolution-options"
            value={selectedOption?.value}
            onChange={(option) => onChange(option)}
            options={options}
            disabled={disabled}
            placeholder="Select action..."
        />
    );
};

ResolutionOptions.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    mode: PropTypes.oneOf(['reschedule', 'repeat']),
    disabled: PropTypes.bool
};

export default ResolutionOptions;
